export { RelatedReviews } from "./related-reviews";
